import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { navContextSearchSchema } from '~/features/catalog-enrichment/utils/nav-context';

const RunProductJourneyPage = lazy(
  () => import('~/features/catalog-enrichment/pages/run-product-journey-page'),
);

/** S8 — `from`/`back`: this page is also reached from a product's own history (not just the
 *  batch Products tab it's nested under), so it needs the same origin trail as every other
 *  destination route. */
const searchSchema = z.object({ ...navContextSearchSchema });

/**
 * One product's full journey in this batch (design round 2, item 7's "Full details ›"): the
 * journey drawer's former whole-accordion detail, now its own page — Summary, Content generation
 * changes (the drawer's old diff cards), and the Journey (every stage, every attempt, data
 * in → out, delivery rows). Nested under the run shell, so it keeps the batch header/tabs.
 */
export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-enrichment/runs/$runId/products/$productId',
)({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { runId, productId } = Route.useParams();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <RunProductJourneyPage runId={runId} productId={productId} />
    </Suspense>
  );
}
